/**
 * Daily Tips Section Component
 * Provides actionable tips and recommendations
 */
import { Sparkles, Camera } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';

interface DailyTipsSectionProps {
  navigate: (path: string) => void;
}

export default function DailyTipsSection({ navigate }: DailyTipsSectionProps) {
  return (
    <Card className="border-2 border-gray-200 shadow-xl bg-gradient-to-br from-amber-50 to-orange-50">
      <CardHeader>
        <CardTitle className="text-slate-800 flex items-center">
          <Sparkles className="w-5 h-5 mr-2 text-amber-500" />
          Daily Tip
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          <p className="text-slate-700">
            Adding more recent photos can increase your profile views by up to 40%!
          </p>
          <Button 
            size="sm" 
            className="bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white"
            onClick={() => navigate('/profile#photos')}
          >
            <Camera className="w-4 h-4 mr-2" />
            Add Photos
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}